/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Reset_Password_TitleInputs */

const en_auth_reset_password_title = /** @type {(inputs: Auth_Reset_Password_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset Password`)
};

const es_auth_reset_password_title = /** @type {(inputs: Auth_Reset_Password_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva contrasena`)
};

/**
* | output |
* | --- |
* | "Reset Password" |
*
* @param {Auth_Reset_Password_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_reset_password_title = /** @type {((inputs?: Auth_Reset_Password_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Reset_Password_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_reset_password_title(inputs)
	return es_auth_reset_password_title(inputs)
});